import React, {useEffect, useState} from 'react';
import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { Box, Button, Modal, Typography, Paper } from '@mui/material';
import { toStoryIntro } from '../../utils/routes';
import { useTranslation } from 'react-i18next';

export default function Frame(props) {

    const {storyId} = useParams();
    const {t, i18n} = useTranslation()

    const navigate = useNavigate();

    const [frame, choices, character, bubble, moveToFrame] = useOutletContext();

    const [dialogOpen, setDialogOpen] = useState(false);
    const [bubbleText, setBubbleText] = useState("");
    const [choicesTexts, setChoicesTexts] = useState(choices ? choices["answers"].map(v => v.answer) : []);

    useEffect(() => {
        setBubbleText(bubble.content[i18n.language])
    }, [i18n.language, bubble.content])

    useEffect(() => {
        if (choices?.answers) {
            setChoicesTexts(choices["answers"].map(v => v.answer[i18n.language]))
        }
    }, [i18n.language, bubble.content])

    const handleOpen = () => {
        setDialogOpen(true);
    };
    const handleClose = () => {
        setDialogOpen(false)
    };

    const handleChoice = (nextFrame, identifier) => {

        let bestAnswer = choices.answers.find(v => {
            return v.correct
        })
        props.updateStoryProgress(storyId, choices.relevant, identifier, bestAnswer.identifier);

        moveToFrame(nextFrame)
    }

    const renderChoices = () => {
        let choicesJS = [];

        if (choices.answers) {
            Object.entries(choices.answers).forEach(([k,v], index) => {
                choicesJS.push(
                    <Box key={k}>
                        <Button onClick={() => handleChoice(v.nextFrame, v.identifier)}
                            sx={{mb: 1, display: "block"}} variant="contained" color="secondary"
                        >{choicesTexts[index]}</Button>
                    </Box>
                )
            })
        }
        return choicesJS;
    }

    return(
        <Box>
        <Paper sx={{p: {xs: 1, sm: 2}, maxWidth: "17rem", position: "relative"}}>
        <Box sx={{display: "flex", flexDirection: "column", alignItems: "center"}}>
        {
            frame.backgroundImage
            ?
            <img style={{width: "16rem", height: "26rem"}} src={frame.backgroundImage} alt="background"/>
            :<Box sx={{backgroundColor: "#000", width: "16rem", height: "26rem"}}></Box>
        }
        {
            character?.imageSrc &&
            <img style={{
                position: "absolute", bottom: character.position.y + "%",
                left: character.position.x + "%", 
                height: character.height + "%"
            }} src={character.imageSrc} alt="character"/>
        }
        {
            bubble?.content &&
            <Box sx={{
                position: "absolute", bottom: bubble.position.y + "%",
                left: bubble.position.x + "%",
                fontSize: bubble.fontSize + "px",
                lineHeight: "24px",
                width: bubble.width + "%",
                background: "#fff",
                borderRadius: "40px",
                padding: "24px",
                textAlign: "center",
                color: "#000"
            }}>
                {bubbleText}
            </Box>
        }
        {
            choices?.answers &&
            <Box sx={{
                position: "absolute",
                bottom: choices.position.y + "%",
                left: choices.position.x + "%",
            }}>
                {renderChoices()}
            </Box>
        }

        <Modal
            open={dialogOpen}
            onClose={handleClose}
        >
            <Paper
                sx={{
                    position: 'absolute',
                    maxWidth: "17rem",
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center"
                }}
            >
                <Typography>
                    {t("comicsAbort")}
                </Typography>
                <Box sx={{mt: 3, display: "flex", justifyContent: "space-around", width: "100%"}}>
                    <Button variant="contained" onClick={handleClose}>{t("no")}</Button>
                    <Button variant="contained" color="error" onClick={() => navigate(toStoryIntro)}>{t("abort")}</Button>
                </Box>
            </Paper>
        </Modal>
        </Box>
        </Paper>
        {
            (!choices?.answers || choices.answers.length === 0) && //!endScreen &&
            <Box sx={{
                display: "flex", justifyContent: "center" 
            }}>
                <Button variant="contained"
                        color="error" sx={{mr: 2}} onClick={handleOpen}
                >{t("abort")}</Button>
                <Button variant="contained" onClick={() => moveToFrame(frame.nextFrameId)}>{t("goOn")}</Button>
            </Box>
        }
        </Box>



    )
}